import React, {useState} from "react";
import Box from "@mui/material/Box";
import TablePagination from "@mui/material/TablePagination";

const PaginatedComponentInternalState = ({children, size, totalElements, handleChangePage, handleChangeRowsPerPage}) => {

    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(25);

    const _handleChangePage = (event, newPage) => {
        setPage(newPage);
        handleChangePage(newPage, rowsPerPage);
    };

    const _handleChangeRowsPerPage = (event) => {
        setPage(0);
        const size = parseInt(event.target.value, 10)
        setRowsPerPage(size);
        handleChangeRowsPerPage(size);
    };

    return (
        <>
            <Box sx={{padding: 2}}>{size > 0 && <TablePagination
                component="div"
                count={totalElements}
                page={page}
                onPageChange={_handleChangePage}
                rowsPerPage={rowsPerPage}
                onRowsPerPageChange={_handleChangeRowsPerPage}
                labelRowsPerPage={"Items per page:"}
            />}
            </Box>
            {children}
            <Box sx={{padding: 2}}>{size > 0 && <TablePagination
                component="div"
                count={totalElements}
                page={page}
                onPageChange={_handleChangePage}
                rowsPerPage={rowsPerPage}
                onRowsPerPageChange={_handleChangeRowsPerPage}
                labelRowsPerPage={"Items per page:"}
            />}
            </Box>
        </>
    )
}

export default PaginatedComponentInternalState;
